<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.sensorType' : 'misc.edition.sensorType') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="typeForm" *ngIf="typeForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="sensor">{{'model.sensorType' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="sensor" type="text" formControlName="sensor" class="w-full">
        </div>
        <app-validation-errors [control]="typeForm.get('sensor')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="unit">{{'attribute.unit' | transloco}}</label>
        </div>
        <div class="col-12 p-fluid">
          <p-autoComplete formControlName="unit" [showEmptyMessage]="true" [suggestions]="filteredUnits" class="w-full"
                          (completeMethod)="filterUnit($event)" [minLength]="1" id="unit"></p-autoComplete>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="dataType">{{'attribute.dataType' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-dropdown
            *ngIf="dataTypes"
            [placeholder]="'select.type' | transloco"
            [filter]="false"
            [options]="dataTypes"
            [showClear]="true"
            styleClass="w-full"
            formControlName="dataType"
            id="dataType"
          >
            <ng-template let-dataType pTemplate="selectedItem"> {{dataType.label | transloco}} </ng-template>
            <ng-template let-dataType pTemplate="item"> {{dataType.label | transloco}} </ng-template>
          </p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            formControlName="tenant"
          ></p-dropdown>
        </div>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/system/sensor-types'"
        pButton
        class="p-button-danger"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="typeForm" [disabled]="!typeForm.valid"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [loading]="persistingChanges"
        (onClick)="persistTypeData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
